<div style="overflow-x:auto;">
  <div class="div-center">
    <h1>Tag-Bib</h1>
    <h6>Файл для загрузки должен содержать 2 столбца: bib;tag или bib(табуляция)tag</h6>
    <div class="button-group">
      <button class="button-main-outline" (click)="openAddTagBibDialog(addTagBibContent)">Добавить</button>
      <button class="button-main-outline" (click)="openGenerateDialog(generateTagBibContent)">Сгенерировать по диапазонам</button>
    </div>
  </div>
  <div class="div-center">
    <input type="file" class="button-main-outline" style="display: none" (change)="uploadCsv($event)"/>
    <label class="button-main-outline" (click)="uploadCsv($event)">
      <input id="upload-csv" type="file" style="display: none" accept=".csv" (change)="uploadCsv($event)">
      Upload Tag-Bib
    </label>
    <button class="button-main-danger" (click)="clearTagBibs()">Очистить привязки</button>
  </div>
  <div class="table-container">
    <table class="styled-table">
      <thead>
      <tr>
        <th>#</th>
        <th>id</th>
        <th (click)="sortBy('bib')" class="sortable">
          bib
          <span class="sort-icon" [class.active]="sortField === 'bib'">
            {{ sortDirection === 'asc' ? '↑' : '↓' }}
          </span>
        </th>
        <th>tag</th>
        <th>eventId</th>
        <th>participantId</th>
        <th (click)="sortBy('updatedAt')" class="sortable">
          updatedAt
          <span class="sort-icon" [class.active]="sortField === 'updatedAt'">
            {{ sortDirection === 'asc' ? '↑' : '↓' }}
          </span>
        </th>
      </tr>
      </thead>
      <tbody>
      <ng-container
        *ngFor="let obj of sortedData"
        style="background-color: #000000;">
        <tr>
          <td>{{data.indexOf(obj) + 1}}</td>
          <td>{{obj?.id}}</td>
          <td>{{obj?.bib}}</td>
          <td>{{obj?.tag}}</td>
          <td>{{obj?.eventId}}</td>
          <td>{{obj?.usedByParticipant}}</td>
          <td>{{getTimestamp(obj?.updatedAt)}}</td>
        </tr>
      </ng-container>
      </tbody>
    </table>
  </div>
</div>

<ng-template #addTagBibContent let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Добавить Tag-Bib</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="tagBibForm" (ngSubmit)="onSubmitTagBib(modal)">
      <div class="form-group mb-3">
        <label for="bib">Номер (Bib) *</label>
        <input type="text" id="bib" formControlName="bib" class="form-control"
               placeholder="Введите номера через пробел или запятую (например: 1 2,3 4,5)">
        <small class="form-text text-muted">
          Можно вводить несколько номеров через пробел или запятую (например: 1 2,3 4,5)
        </small>
      </div>

      <div class="form-group mb-3">
        <label for="tag">Tag *</label>
        <input type="text" id="tag" formControlName="tag" class="form-control"
               placeholder="Введите tag">
      </div>

      <div class="modal-footer">
        <button type="submit" class="button-main-blue"
                [disabled]="!tagBibForm.valid">Сохранить</button>
        <button type="button" class="button-main-outline"
                (click)="modal.dismiss()">Отмена</button>
      </div>
    </form>
  </div>
</ng-template>

<ng-template #generateTagBibContent let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Сгенерировать Tag-Bib по диапазонам</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="generateForm" (ngSubmit)="onSubmitGenerate(modal)">
      <div class="form-group mb-3">
        <label for="ranges">Диапазоны номеров *</label>
        <input type="text" id="ranges" formControlName="ranges" class="form-control"
               placeholder="Например: 1-10, 15-20, 25">
        <small class="form-text text-muted">
          Введите диапазоны через запятую. Каждый диапазон может быть числом или интервалом через дефис (например: 1-10, 15-20, 25)
        </small>
      </div>

      <div class="form-group mb-3">
        <label for="tagPrefix">Префикс тега</label>
        <input type="text" id="tagPrefix" formControlName="tagPrefix" class="form-control"
               placeholder="Например: TAG">
        <small class="form-text text-muted">
          К каждому номеру будет добавлен этот префикс (например: TAG001, TAG002 и т.д.)
        </small>
      </div>

      <div class="form-group mb-3">
        <label for="padding">Длина номера</label>
        <input type="number" id="padding" formControlName="padding" class="form-control"
               placeholder="Например: 3" min="1" max="10">
        <small class="form-text text-muted">
          Количество цифр в номере (например: 3 для 001, 002 и т.д.)
        </small>
      </div>

      <div class="modal-footer">
        <button type="submit" class="button-main-blue"
                [disabled]="!generateForm.valid">Сгенерировать</button>
        <button type="button" class="button-main-outline"
                (click)="modal.dismiss()">Отмена</button>
      </div>
    </form>
  </div>
</ng-template>
